import { render, staticRenderFns } from "./DialogProductThankYou.vue?vue&type=template&id=5f3ff958&scoped=true"
import script from "./DialogProductThankYou.vue?vue&type=script&lang=js"
export * from "./DialogProductThankYou.vue?vue&type=script&lang=js"
import style0 from "./DialogProductThankYou.vue?vue&type=style&index=0&id=5f3ff958&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ff958",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f3ff958')) {
      api.createRecord('5f3ff958', component.options)
    } else {
      api.reload('5f3ff958', component.options)
    }
    module.hot.accept("./DialogProductThankYou.vue?vue&type=template&id=5f3ff958&scoped=true", function () {
      api.rerender('5f3ff958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/AiAssistance/Components/Dialogs/DialogProductThankYou.vue"
export default component.exports